<template>
 <el-container class="process-definition-list pagination-list">
      <el-main>
        <div class="content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item label="">
              <el-input v-model="conditions.keyword" placeholder="请输入流程名称" @keyup.enter.native="search" clearable/>
              <el-button class="search-button" @click="search">查询</el-button>
            </el-form-item>
            <el-form-item class="operation-buttons">
              <el-button @click="addRow" type="primary">新建流程</el-button>
            </el-form-item>
           </el-form >
          <table-list
            ref="tableList"
            :type="'process'"
            :items="items"
            :cols="cols"
            :loading="loading"
            :pagination="pagination"
            @saveAs="saveAs"
            @changePagination="changePagination"
            @editRow="editRow"
            @delRow="delRow"
            ></table-list>
        </div>
      </el-main>
      <public-design-dialog v-if="designDialog.visiable" :designDialog="designDialog" @closeForm="close"></public-design-dialog>
  </el-container>

</template>
<script>
import PublicDesignDialog from '@/components/shared/public-design-dialog.vue'
import TableList from '../../shared/table-list.vue'
export default {
  name: 'processDesignList',
  components: {
    TableList,
    PublicDesignDialog
  },
  data () {
    return {
      conditions: { keyword: '' },
      pagination: { currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0 },
      loading: false,
      items: [],
      options: [],
      cols: [
        { prop: 'name', label: '流程名称', width: '217px' },
        { prop: 'category', label: '流程分类' },
        { prop: 'creator', label: '创建人' },
        { prop: 'createTime', label: '创建时间', width: '160px' },
        { prop: 'lastModifiedBy', label: '更新人' },
        { prop: 'lastModifiedDate', label: '更新时间', width: '160px' }
      ],
      filters: {},
      designDialog: {
        visiable: false,
        id: '',
        type: 'process',
        changePage: true
      }
    }
  },
  created () {
    this.getTableData()
    this.loadCategory()
  },

  methods: {
    addRow () {
      this.designDialog.id = ''
      this.designDialog.visiable = true
      this.designDialog.changePage = true
    },
    editRow (row) {
      this.designDialog.id = row.id
      this.designDialog.visiable = true
      this.designDialog.changePage = false
    },
    delRow (row) {
      let processId = row.id
      this.$confirm('', '你确定要删除吗?', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        customClass: 'deleMessageBox',
        center: true
      })
        .then(() => this.$axios.delete('/process-api/processes/' + processId))
        .then(res => {
          this.getTableData()
        })
    },
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.initParams()
    },
    initParams () {
      this.filters = {
        'keyword': this.conditions.keyword.trim(),
        'category': '',
        'isPublish': ''
      }
      this.getTableData()
    },
    reset () {
      this.conditions.keyword = ''
      this.pagination.currentPage = 1
      this.filters = {}
      this.getTableData()
    },
    loadCategory () {
      this.$axios.get('/process-api/processes/categorys').then(res => {
        this.options = res.data
      })
    },
    // 调用接口获取tableData数据
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      params.filters = this.filters
      this.$axios.get('/process-api/processes', {params})
        .then((res) => {
          // 页面数据改变重新统计数据数量和当前页
          this.pagination.total = res.data.total
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
            return
          }
          this.items = res.data.items
          this.loading = false
          this.$nextTick(() => {
            // 翻页的时候让滚动条调整到最上方
            if (this.$refs.tableList && this.$refs.tableList.$refs && this.$refs.tableList.$refs.table) {
              this.$refs.tableList.$refs.table.bodyWrapper.scrollTop = 0
            }
          })
        }).catch(() => {
          this.loading = false
        })
    },
    changePagination (val) {
      this.pagination = val
      this.getTableData()
    },
    close () {
      if (this.designDialog.changePage) {
        this.pagination.currentPage = 1
      }
      this.initParams()
    },
    saveAs (row, copyLoading) {
      this.$axios.get(`/process-api/processes/saveAs/${row.id}`)
        .then(() => {
          copyLoading.close()
          this.$message({
            message: '复制成功',
            center: true,
            duration: 1000,
            customClass: 'without-execute-dialog'
          })
          this.search()
        })
        .catch(error => {
          this.$message.error(error.response.data ? error.response.data.message : error.message)
          copyLoading.close()
        })
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/common.scss';
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-definition-list.vue